import {MarginSizes} from "./types";

export const getMarginClass = (prefix: string, size: MarginSizes) => {
  if (size === "md") {
    return `svv-${prefix || 'text'}--spacing`
  } 
    return `svv-${prefix || 'text'}--spacing--${size}`
  
}
